const appConfig = {
  disableLoginPage: true,
  onlyAllowEmbedded: false,
};

export default appConfig;